<!-- <template>
  <div class="">
    <nav class="sidebar-navigation">
      <ul>
        <li class="active">
          <router-link to="/" class="inline-block">
            <img
              class="h-12 rounded mx-auto single-link"
              src="../../assets/images/icon-legalleria.svg"
              alt=""
            />
          </router-link>
        </li>
        <li
          :class="['single-nav-link', routeEqContains('/', 1) ? 'active' : '']"
        >
          <router-link to="/" class="inline-block rounded mx-auto single-link">
            <svg
              width="24"
              height="24"
              viewbox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 13H3C2.73478 13 2.48043 13.1054 2.29289 13.2929C2.10536 13.4804 2 13.7348 2 14V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22H10C10.2652 22 10.5196 21.8946 10.7071 21.7071C10.8946 21.5196 11 21.2652 11 21V14C11 13.7348 10.8946 13.4804 10.7071 13.2929C10.5196 13.1054 10.2652 13 10 13ZM9 20H4V15H9V20ZM21 2H14C13.7348 2 13.4804 2.10536 13.2929 2.29289C13.1054 2.48043 13 2.73478 13 3V10C13 10.2652 13.1054 10.5196 13.2929 10.7071C13.4804 10.8946 13.7348 11 14 11H21C21.2652 11 21.5196 10.8946 21.7071 10.7071C21.8946 10.5196 22 10.2652 22 10V3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2ZM20 9H15V4H20V9ZM21 13H14C13.7348 13 13.4804 13.1054 13.2929 13.2929C13.1054 13.4804 13 13.7348 13 14V21C13 21.2652 13.1054 21.5196 13.2929 21.7071C13.4804 21.8946 13.7348 22 14 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21V14C22 13.7348 21.8946 13.4804 21.7071 13.2929C21.5196 13.1054 21.2652 13 21 13ZM20 20H15V15H20V20ZM10 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V10C2 10.2652 2.10536 10.5196 2.29289 10.7071C2.48043 10.8946 2.73478 11 3 11H10C10.2652 11 10.5196 10.8946 10.7071 10.7071C10.8946 10.5196 11 10.2652 11 10V3C11 2.73478 10.8946 2.48043 10.7071 2.29289C10.5196 2.10536 10.2652 2 10 2ZM9 9H4V4H9V9Z"
                fill="currentColor"
              ></path>
            </svg>
          </router-link>
          <span :class="[routeEqContains('/', 1) ? 'invisible' : 'tooltip']"
            >Početna</span
          >
        </li>
        <li
          :class="[
            'single-nav-link',
            routeEqContains('/case', 2) ? 'active' : '',
          ]"
        >
          <router-link
            to="/case"
            class="inline-block rounded mx-auto single-link"
          >
            <svg
              width="20"
              height="20"
              viewbox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 4C9.73478 4 9.48043 4.10536 9.29289 4.29289C9.10536 4.48043 9 4.73478 9 5V15C9 15.2652 9.10536 15.5196 9.29289 15.7071C9.48043 15.8946 9.73478 16 10 16C10.2652 16 10.5196 15.8946 10.7071 15.7071C10.8946 15.5196 11 15.2652 11 15V5C11 4.73478 10.8946 4.48043 10.7071 4.29289C10.5196 4.10536 10.2652 4 10 4ZM5 10C4.73478 10 4.48043 10.1054 4.29289 10.2929C4.10536 10.4804 4 10.7348 4 11V15C4 15.2652 4.10536 15.5196 4.29289 15.7071C4.48043 15.8946 4.73478 16 5 16C5.26522 16 5.51957 15.8946 5.70711 15.7071C5.89464 15.5196 6 15.2652 6 15V11C6 10.7348 5.89464 10.4804 5.70711 10.2929C5.51957 10.1054 5.26522 10 5 10ZM15 8C14.7348 8 14.4804 8.10536 14.2929 8.29289C14.1054 8.48043 14 8.73478 14 9V15C14 15.2652 14.1054 15.5196 14.2929 15.7071C14.4804 15.8946 14.7348 16 15 16C15.2652 16 15.5196 15.8946 15.7071 15.7071C15.8946 15.5196 16 15.2652 16 15V9C16 8.73478 15.8946 8.48043 15.7071 8.29289C15.5196 8.10536 15.2652 8 15 8ZM17 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H17C17.7956 20 18.5587 19.6839 19.1213 19.1213C19.6839 18.5587 20 17.7956 20 17V3C20 2.20435 19.6839 1.44129 19.1213 0.87868C18.5587 0.316071 17.7956 0 17 0ZM18 17C18 17.2652 17.8946 17.5196 17.7071 17.7071C17.5196 17.8946 17.2652 18 17 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H17C17.2652 2 17.5196 2.10536 17.7071 2.29289C17.8946 2.48043 18 2.73478 18 3V17Z"
                fill="currentColor"
              ></path>
            </svg>
          </router-link>
          <span :class="[routeEqContains('/case', 2) ? 'invisible' : 'tooltip']"
            >Predmet</span
          >
        </li>
        <li
          :class="[
            'single-nav-link',
            routeEqContains('/files', 3) ? 'active' : '',
          ]"
        >
          <router-link
            to="files"
            class="inline-block rounded mx-auto single-link"
          >
            <svg
              width="22px"
              height="22px"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  d="M13 3L13.7071 2.29289C13.5196 2.10536 13.2652 2 13 2V3ZM19 9H20C20 8.73478 19.8946 8.48043 19.7071 8.29289L19 9ZM13.109 8.45399L14 8V8L13.109 8.45399ZM13.546 8.89101L14 8L13.546 8.89101ZM10 13C10 12.4477 9.55228 12 9 12C8.44772 12 8 12.4477 8 13H10ZM8 16C8 16.5523 8.44772 17 9 17C9.55228 17 10 16.5523 10 16H8ZM8.5 9C7.94772 9 7.5 9.44772 7.5 10C7.5 10.5523 7.94772 11 8.5 11V9ZM9.5 11C10.0523 11 10.5 10.5523 10.5 10C10.5 9.44772 10.0523 9 9.5 9V11ZM8.5 6C7.94772 6 7.5 6.44772 7.5 7C7.5 7.55228 7.94772 8 8.5 8V6ZM9.5 8C10.0523 8 10.5 7.55228 10.5 7C10.5 6.44772 10.0523 6 9.5 6V8ZM17.908 20.782L17.454 19.891L17.454 19.891L17.908 20.782ZM18.782 19.908L19.673 20.362L18.782 19.908ZM5.21799 19.908L4.32698 20.362H4.32698L5.21799 19.908ZM6.09202 20.782L6.54601 19.891L6.54601 19.891L6.09202 20.782ZM6.09202 3.21799L5.63803 2.32698L5.63803 2.32698L6.09202 3.21799ZM5.21799 4.09202L4.32698 3.63803L4.32698 3.63803L5.21799 4.09202ZM12 3V7.4H14V3H12ZM14.6 10H19V8H14.6V10ZM12 7.4C12 7.66353 11.9992 7.92131 12.0169 8.13823C12.0356 8.36682 12.0797 8.63656 12.218 8.90798L14 8C14.0293 8.05751 14.0189 8.08028 14.0103 7.97537C14.0008 7.85878 14 7.69653 14 7.4H12ZM14.6 8C14.3035 8 14.1412 7.99922 14.0246 7.9897C13.9197 7.98113 13.9425 7.9707 14 8L13.092 9.78201C13.3634 9.92031 13.6332 9.96438 13.8618 9.98305C14.0787 10.0008 14.3365 10 14.6 10V8ZM12.218 8.90798C12.4097 9.2843 12.7157 9.59027 13.092 9.78201L14 8V8L12.218 8.90798ZM8 13V16H10V13H8ZM8.5 11H9.5V9H8.5V11ZM8.5 8H9.5V6H8.5V8ZM13 2H8.2V4H13V2ZM4 6.2V17.8H6V6.2H4ZM8.2 22H15.8V20H8.2V22ZM20 17.8V9H18V17.8H20ZM19.7071 8.29289L13.7071 2.29289L12.2929 3.70711L18.2929 9.70711L19.7071 8.29289ZM15.8 22C16.3436 22 16.8114 22.0008 17.195 21.9694C17.5904 21.9371 17.9836 21.8658 18.362 21.673L17.454 19.891C17.4045 19.9162 17.3038 19.9539 17.0322 19.9761C16.7488 19.9992 16.3766 20 15.8 20V22ZM18 17.8C18 18.3766 17.9992 18.7488 17.9761 19.0322C17.9539 19.3038 17.9162 19.4045 17.891 19.454L19.673 20.362C19.8658 19.9836 19.9371 19.5904 19.9694 19.195C20.0008 18.8114 20 18.3436 20 17.8H18ZM18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362L17.891 19.454C17.7951 19.6422 17.6422 19.7951 17.454 19.891L18.362 21.673ZM4 17.8C4 18.3436 3.99922 18.8114 4.03057 19.195C4.06287 19.5904 4.13419 19.9836 4.32698 20.362L6.10899 19.454C6.0838 19.4045 6.04612 19.3038 6.02393 19.0322C6.00078 18.7488 6 18.3766 6 17.8H4ZM8.2 20C7.62345 20 7.25117 19.9992 6.96784 19.9761C6.69617 19.9539 6.59545 19.9162 6.54601 19.891L5.63803 21.673C6.01641 21.8658 6.40963 21.9371 6.80497 21.9694C7.18864 22.0008 7.65645 22 8.2 22V20ZM4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673L6.54601 19.891C6.35785 19.7951 6.20487 19.6422 6.10899 19.454L4.32698 20.362ZM8.2 2C7.65645 2 7.18864 1.99922 6.80497 2.03057C6.40963 2.06287 6.01641 2.13419 5.63803 2.32698L6.54601 4.10899C6.59545 4.0838 6.69617 4.04612 6.96784 4.02393C7.25117 4.00078 7.62345 4 8.2 4V2ZM6 6.2C6 5.62345 6.00078 5.25117 6.02393 4.96784C6.04612 4.69617 6.0838 4.59545 6.10899 4.54601L4.32698 3.63803C4.13419 4.01641 4.06287 4.40963 4.03057 4.80497C3.99922 5.18864 4 5.65645 4 6.2H6ZM5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803L6.10899 4.54601C6.20487 4.35785 6.35785 4.20487 6.54601 4.10899L5.63803 2.32698Z"
                  fill="currentColor"
                ></path>
              </g>
            </svg>
          </router-link>
          <span :class="[routeEqContains('/files', 3) ? 'invisible' : 'tooltip']"
            >Dijeljeni dokumenti</span
          >
        </li>
        <li
          :class="[
            'single-nav-link',
            routeEqContains('/calendar', 4) ? 'active' : '',
          ]"
        >
          <router-link
            to="/calendar"
            class="inline-block rounded mx-auto single-link"
          >
            <svg
            width="22px"
              height="22px"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  d="M3 9H21M7 3V5M17 3V5M6 12H8M11 12H13M16 12H18M6 15H8M11 15H13M16 15H18M6 18H8M11 18H13M16 18H18M6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V8.2C21 7.07989 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                ></path>
              </g>
            </svg>
          </router-link>
          <span
            :class="[routeEqContains('/calendar', 4) ? 'invisible' : 'tooltip']"
            >Ročišnik</span
          >
        </li>
      </ul>
      <ul>
        <li :class="['single-nav-link logout']" @click="handleLogout()">
          <a href="" class="inline-block rounded-full mx-auto single-link ">
            <svg
              width="20"
              height="20"
              viewbox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.59 11.0001L8.29 13.2901C8.19627 13.3831 8.12188 13.4937 8.07111 13.6155C8.02034 13.7374 7.9942 13.8681 7.9942 14.0001C7.9942 14.1321 8.02034 14.2628 8.07111 14.3847C8.12188 14.5065 8.19627 14.6171 8.29 14.7101C8.38296 14.8038 8.49356 14.8782 8.61542 14.929C8.73728 14.9798 8.86799 15.0059 9 15.0059C9.13201 15.0059 9.26272 14.9798 9.38458 14.929C9.50644 14.8782 9.61704 14.8038 9.71 14.7101L13.71 10.7101C13.801 10.615 13.8724 10.5029 13.92 10.3801C14.02 10.1366 14.02 9.86356 13.92 9.6201C13.8724 9.49735 13.801 9.3852 13.71 9.2901L9.71 5.2901C9.61676 5.19686 9.50607 5.1229 9.38425 5.07244C9.26243 5.02198 9.13186 4.99601 9 4.99601C8.86814 4.99601 8.73757 5.02198 8.61575 5.07244C8.49393 5.1229 8.38324 5.19686 8.29 5.2901C8.19676 5.38334 8.1228 5.49403 8.07234 5.61585C8.02188 5.73767 7.99591 5.86824 7.99591 6.0001C7.99591 6.13196 8.02188 6.26253 8.07234 6.38435C8.1228 6.50617 8.19676 6.61686 8.29 6.7101L10.59 9.0001H1C0.734784 9.0001 0.48043 9.10546 0.292893 9.29299C0.105357 9.48053 0 9.73488 0 10.0001C0 10.2653 0.105357 10.5197 0.292893 10.7072C0.48043 10.8947 0.734784 11.0001 1 11.0001H10.59ZM10 9.96937e-05C8.13109 -0.00824409 6.29724 0.507313 4.70647 1.48829C3.11569 2.46927 1.83165 3.87641 1 5.5501C0.880653 5.78879 0.861015 6.06512 0.945406 6.3183C1.0298 6.57147 1.21131 6.78075 1.45 6.9001C1.68869 7.01945 1.96502 7.03909 2.2182 6.95469C2.47137 6.8703 2.68065 6.68879 2.8 6.4501C3.43219 5.17342 4.39383 4.08872 5.58555 3.30809C6.77727 2.52746 8.15582 2.07922 9.57876 2.00969C11.0017 1.94017 12.4174 2.25188 13.6795 2.91261C14.9417 3.57334 16.0045 4.55913 16.7581 5.7681C17.5118 6.97706 17.9289 8.36535 17.9664 9.78948C18.0039 11.2136 17.6605 12.6219 16.9715 13.8689C16.2826 15.1159 15.2731 16.1563 14.0475 16.8825C12.8219 17.6088 11.4246 17.9946 10 18.0001C8.50888 18.0066 7.04615 17.5925 5.77969 16.8053C4.51323 16.0182 3.49435 14.89 2.84 13.5501C2.72065 13.3114 2.51137 13.1299 2.2582 13.0455C2.00502 12.9611 1.72869 12.9808 1.49 13.1001C1.25131 13.2194 1.0698 13.4287 0.985406 13.6819C0.901015 13.9351 0.920653 14.2114 1.04 14.4501C1.83283 16.0456 3.03752 17.4003 4.52947 18.3741C6.02142 19.348 7.74645 19.9055 9.52612 19.9891C11.3058 20.0727 13.0755 19.6793 14.6521 18.8496C16.2288 18.0199 17.5552 16.7841 18.4941 15.2699C19.433 13.7558 19.9503 12.0182 19.9925 10.2371C20.0347 8.45597 19.6003 6.69589 18.7342 5.13893C17.8682 3.58197 16.6018 2.28467 15.0663 1.38121C13.5307 0.477745 11.7816 0.000936146 10 9.96937e-05Z"
                fill="currentColor"
              ></path>
            </svg>
          </a>
          <span class="tooltip">Odjava</span>
        </li>
      </ul>
    </nav>
  </div>
</template> -->

<template>
  <div>
    <nav
      class="h-full float-left opacity-100 bg-gray-800 px-2 py-3 fixed flex flex-col justify-between"
      id="navbar"
    >
      <router-link to="/" class="inline-block mb-12" id="step1">
        <img
          class="h-12 rounded mx-auto single-link"
          src="../../assets/images/icon-legalleria.svg"
          alt=""
        />
      </router-link>
      <div class="mb-6" id="nav-bar-links">
        <ul>
          <li
            class="single-link"
            data-tooltip-target="index-page-tooltip"
            data-tooltip-placement="right"
          >
            <!-- text-gray-400' -->
            <router-link
              to="/"
              :class="[
                'flex items-center justify-center w-12 h-12 rounded-xl  hover:text-blue-500 hover:bg-gray-800',
                routeEqContains('/', 1)
                  ? 'bg-gray-800 text-blue-500'
                  : 'text-gray-400',
              ]"
            >
              <svg
                width="24"
                height="24"
                viewbox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 13H3C2.73478 13 2.48043 13.1054 2.29289 13.2929C2.10536 13.4804 2 13.7348 2 14V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22H10C10.2652 22 10.5196 21.8946 10.7071 21.7071C10.8946 21.5196 11 21.2652 11 21V14C11 13.7348 10.8946 13.4804 10.7071 13.2929C10.5196 13.1054 10.2652 13 10 13ZM9 20H4V15H9V20ZM21 2H14C13.7348 2 13.4804 2.10536 13.2929 2.29289C13.1054 2.48043 13 2.73478 13 3V10C13 10.2652 13.1054 10.5196 13.2929 10.7071C13.4804 10.8946 13.7348 11 14 11H21C21.2652 11 21.5196 10.8946 21.7071 10.7071C21.8946 10.5196 22 10.2652 22 10V3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2ZM20 9H15V4H20V9ZM21 13H14C13.7348 13 13.4804 13.1054 13.2929 13.2929C13.1054 13.4804 13 13.7348 13 14V21C13 21.2652 13.1054 21.5196 13.2929 21.7071C13.4804 21.8946 13.7348 22 14 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21V14C22 13.7348 21.8946 13.4804 21.7071 13.2929C21.5196 13.1054 21.2652 13 21 13ZM20 20H15V15H20V20ZM10 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V10C2 10.2652 2.10536 10.5196 2.29289 10.7071C2.48043 10.8946 2.73478 11 3 11H10C10.2652 11 10.5196 10.8946 10.7071 10.7071C10.8946 10.5196 11 10.2652 11 10V3C11 2.73478 10.8946 2.48043 10.7071 2.29289C10.5196 2.10536 10.2652 2 10 2ZM9 9H4V4H9V9Z"
                  fill="currentColor"
                ></path>
              </svg>
            </router-link>
          </li>
          <div
            id="index-page-tooltip"
            role="tooltip"
            class="absolute invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700"
          >
            Početna
          </div>
          <li
            class="single-link group relative"
            data-tooltip-target="cases-page-tooltip"
            data-tooltip-placement="right"
          >
            <router-link
              to="/case"
              :class="[
                'flex items-center justify-center w-12 h-12 rounded-xl  hover:text-blue-500 hover:bg-gray-800',
                routeEqContains('/case', 2)
                  ? 'bg-gray-800 text-blue-500'
                  : 'text-gray-400',
              ]"
            >
              <svg
                width="22"
                height="22"
                fill="currentColor"
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 512 512"
                xml:space="preserve"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <g>
                    <g>
                      <rect
                        x="248.155"
                        y="144.862"
                        width="14.644"
                        height="15.69"
                      ></rect>
                    </g>
                  </g>
                  <g>
                    <g>
                      <rect
                        x="80.794"
                        y="320.592"
                        width="14.644"
                        height="15.69"
                      ></rect>
                    </g>
                  </g>
                  <g>
                    <g>
                      <path
                        d="M167.844,464.29V512h175.79v-47.71H167.844z M327.944,496.31h-144.41v-16.329h144.41V496.31z"
                      ></path>
                    </g>
                  </g>
                  <g>
                    <g>
                      <path
                        d="M493.429,297.578l-45.487-90.974V175.79h39.782v-39.704H292.309c-5.228-12.016-16.206-20.964-29.441-23.365l0.65-66.32 c9.345-3.233,16.076-12.115,16.076-22.546C279.594,10.701,268.894,0,255.739,0c-13.154,0-23.855,10.701-23.855,23.855 c0,10.381,6.668,19.23,15.943,22.501l-0.653,66.651c-12.592,2.769-22.968,11.501-28.006,23.079H23.754v39.704h39.257v31.865 l-44.962,89.923H0.25v7.845c0,17.398,7.376,35.337,20.684,49.217c14.014,14.618,31.852,22.668,50.691,22.668 c18.839,0,36.953-8.05,50.968-22.668c13.307-13.88,20.961-31.819,20.961-49.217v-7.845h-18.355l-44.405-88.813v-32.977h143.025 c5.623,7.506,13.832,12.962,23.29,15.058v225.975h-56.485v24.058h-6.276v15.69h143.303v-15.69h-9.414v-24.058h-55.439V191.161 c10.118-1.817,18.928-7.453,24.86-15.371h143.548v31.934l-44.927,89.854h-17.833v7.845c0,17.398,7.394,35.337,20.701,49.217 c14.014,14.618,31.869,22.668,50.707,22.668c18.839,0,36.937-8.05,50.951-22.668c13.307-13.88,20.944-31.819,20.944-49.217v-7.845 H493.429z M127.147,313.269c-1.844,10.865-7.415,21.661-15.903,30.513c-11.027,11.503-25.099,17.837-39.62,17.837 c-14.521,0-28.593-6.335-39.621-17.837c-2.274-2.371-4.331-4.886-6.17-7.501h46.591v-15.69H17.92 c-0.787-2.424-1.403-4.87-1.818-7.322H127.147z M107.657,297.578H35.591l36.034-72.066L107.657,297.578z M39.444,160.101V160.1 v-8.324h176.434c0,0.053-0.004,0.107-0.004,0.16c0,2.798,0.293,5.528,0.844,8.165H39.444z M247.574,23.855 c0-4.502,3.663-8.165,8.165-8.165s8.165,3.662,8.165,8.165c0,4.503-3.663,8.165-8.165,8.165 C251.237,32.019,247.574,28.357,247.574,23.855z M302.548,432.514v8.368h-96.233v-8.368H302.548z M255.739,176.109 c-13.33,0-24.175-10.845-24.175-24.174c0-13.33,10.845-24.175,24.175-24.175c13.329,0,24.174,10.845,24.174,24.175 C279.914,165.265,269.069,176.109,255.739,176.109z M294.761,160.099c0.551-2.637,0.844-5.366,0.844-8.164 c0-0.053-0.004-0.107-0.004-0.16h176.435v8.324H294.761z M439.855,225.512l36.033,72.066h-72.067L439.855,225.512z M479.474,343.782c-11.027,11.503-25.098,17.837-39.62,17.837c-14.522,0-28.593-6.335-39.621-17.837 c-2.274-2.371-4.331-4.886-6.17-7.501h45.511v-15.69H386.15c-0.787-2.424-1.403-4.87-1.818-7.322h111.043 C493.532,324.133,487.962,334.929,479.474,343.782z"
                      ></path>
                    </g>
                  </g>
                  <g>
                    <g>
                      <rect
                        x="446.897"
                        y="320.592"
                        width="16.736"
                        height="15.69"
                      ></rect>
                    </g>
                  </g>
                </g>
              </svg>
            </router-link>
          </li>
          <div
            id="cases-page-tooltip"
            role="tooltip"
            class="absolute invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700"
          >
            Predmeti
          </div>

          <li
            class="single-link"
            data-tooltip-target="files-page-tooltip"
            data-tooltip-placement="right"
          >
            <router-link
              to="/files"
              :class="[
                'flex items-center justify-center w-12 h-12 rounded-xl  hover:text-blue-500 hover:bg-gray-800',
                routeEqContains('/files', 3)
                  ? 'bg-gray-800 text-blue-500'
                  : 'text-gray-400',
              ]"
            >
              <svg
                width="20"
                height="20"
                viewbox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17 4.5H14V3.5C14 2.70435 13.6839 1.94129 13.1213 1.37868C12.5587 0.816071 11.7956 0.5 11 0.5H9C8.20435 0.5 7.44129 0.816071 6.87868 1.37868C6.31607 1.94129 6 2.70435 6 3.5V4.5H3C2.20435 4.5 1.44129 4.81607 0.87868 5.37868C0.316071 5.94129 0 6.70435 0 7.5V16.5C0 17.2956 0.316071 18.0587 0.87868 18.6213C1.44129 19.1839 2.20435 19.5 3 19.5H17C17.7956 19.5 18.5587 19.1839 19.1213 18.6213C19.6839 18.0587 20 17.2956 20 16.5V7.5C20 6.70435 19.6839 5.94129 19.1213 5.37868C18.5587 4.81607 17.7956 4.5 17 4.5ZM8 3.5C8 3.23478 8.10536 2.98043 8.29289 2.79289C8.48043 2.60536 8.73478 2.5 9 2.5H11C11.2652 2.5 11.5196 2.60536 11.7071 2.79289C11.8946 2.98043 12 3.23478 12 3.5V4.5H8V3.5ZM18 16.5C18 16.7652 17.8946 17.0196 17.7071 17.2071C17.5196 17.3946 17.2652 17.5 17 17.5H3C2.73478 17.5 2.48043 17.3946 2.29289 17.2071C2.10536 17.0196 2 16.7652 2 16.5V11C2.97544 11.3869 3.97818 11.7011 5 11.94V12.53C5 12.7952 5.10536 13.0496 5.29289 13.2371C5.48043 13.4246 5.73478 13.53 6 13.53C6.26522 13.53 6.51957 13.4246 6.70711 13.2371C6.89464 13.0496 7 12.7952 7 12.53V12.32C7.99435 12.4554 8.99649 12.5255 10 12.53C11.0035 12.5255 12.0057 12.4554 13 12.32V12.53C13 12.7952 13.1054 13.0496 13.2929 13.2371C13.4804 13.4246 13.7348 13.53 14 13.53C14.2652 13.53 14.5196 13.4246 14.7071 13.2371C14.8946 13.0496 15 12.7952 15 12.53V11.94C16.0218 11.7011 17.0246 11.3869 18 11V16.5ZM18 8.81C17.0274 9.22049 16.0244 9.55483 15 9.81V9.5C15 9.23478 14.8946 8.98043 14.7071 8.79289C14.5196 8.60536 14.2652 8.5 14 8.5C13.7348 8.5 13.4804 8.60536 13.2929 8.79289C13.1054 8.98043 13 9.23478 13 9.5V10.24C11.0113 10.54 8.98875 10.54 7 10.24V9.5C7 9.23478 6.89464 8.98043 6.70711 8.79289C6.51957 8.60536 6.26522 8.5 6 8.5C5.73478 8.5 5.48043 8.60536 5.29289 8.79289C5.10536 8.98043 5 9.23478 5 9.5V9.83C3.97562 9.57483 2.9726 9.24049 2 8.83V7.5C2 7.23478 2.10536 6.98043 2.29289 6.79289C2.48043 6.60536 2.73478 6.5 3 6.5H17C17.2652 6.5 17.5196 6.60536 17.7071 6.79289C17.8946 6.98043 18 7.23478 18 7.5V8.81Z"
                  fill="currentColor"
                ></path>
              </svg>
              <div
              class="absolute block w-3 h-3  top-1 end-1 "
            >{{file_notifications.length>0 ? file_notifications.length : ""}}</div>
            </router-link>
          </li>
          <div
            id="files-page-tooltip"
            role="tooltip"
            class="absolute invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700"
          >
            Dijeljene datoteke
          </div>

          <li
            class="single-link relative"
            data-tooltip-target="calendar-page-tooltip"
            data-tooltip-placement="right"
          >
            <router-link
              to="/calendar"
              :class="[
                'flex items-center justify-center w-12 h-12 rounded-xl  hover:text-blue-500 hover:bg-gray-800',
                routeEqContains('/calendar', 4)
                  ? 'bg-gray-800 text-blue-500'
                  : 'text-gray-400',
              ]"
              href="#"
            >
              <svg
                width="22px"
                height="22px"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M3 9H21M7 3V5M17 3V5M6 12H8M11 12H13M16 12H18M6 15H8M11 15H13M16 15H18M6 18H8M11 18H13M16 18H18M6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V8.2C21 7.07989 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  ></path>
                </g>
              </svg>
            </router-link>
            <div
              class="absolute block w-3 h-3 bg-green-500 border-2 border-white rounded-full top-2 end-2 dark:border-gray-900"
            ></div>
          </li>

          <div
            id="calendar-page-tooltip"
            role="tooltip"
            class="absolute invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700"
          >
            Ročišnik
          </div>
          <li
            class="single-link"
            data-tooltip-target="comunication-page-tooltip"
            data-tooltip-placement="right"
          >
            <router-link
              to="/comunication"
              :class="[
                'flex items-center justify-center w-12 h-12 rounded-xl  hover:text-blue-500 hover:bg-gray-800',
                routeEqContains('/comunication', 5)
                  ? 'bg-gray-800 text-blue-500'
                  : 'text-gray-400',
              ]"
              href="#"
            >
              <svg
                class=""
                width="24"
                height="24"
                viewBox="-2 -2 24.00 24.00"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                fill="currentColor"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <title>
                    communication / 16 - communication, bubble, chat, comments,
                    conversation, message icon
                  </title>
                  <g
                    id="Free-Icons"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <g
                      transform="translate(-1265.000000, -156.000000)"
                      id="Group"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <g
                        transform="translate(1263.000000, 154.000000)"
                        id="Shape"
                      >
                        <path
                          d="M8.29997591,16.1586109 L4.71,18.3 L5.32628923,14.6238888 C3.83281239,13.3921212 3,11.6856969 3,9.8 C3,6.0444637 6.30329488,3 11.55,3 C16.7967051,3 20.1,6.0444637 20.1,9.8 C20.1,13.5555363 16.7967051,16.6 11.55,16.6 C10.3617053,16.6 9.27309774,16.4438342 8.29997591,16.1586109 Z"
                        ></path>
                        <path
                          d="M19.7000346,12 C20.5370398,12.8311353 21,13.932301 21,15.1401596 C21,16.4401458 20.4637233,17.6165428 19.5020218,18.4657147 L19.8988718,21 L17.587162,19.5237413 C16.9605351,19.7203723 16.259543,19.8280319 15.4943589,19.8280319 C12.7385072,19.8280319 10.8153028,18.4315592 10.2,16.5116586 L10.2,16.5116586"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
              <div
              class="absolute block w-3 h-3  top-1 end-1 "
            >{{comunication_notifications.length>0 ? comunication_notifications.length : ""}}</div>
            </router-link>
          </li>
          <div
            id="comunication-page-tooltip"
            role="tooltip"
            class="absolute invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700"
          >
            Komunikacije
          </div>
          
        </ul>
      </div>
      <div class="mt-auto text-gray-200 text-sm">
        v 2.0.0
        <!-- <a
          href="#"
          data-tooltip-target="avatar-tooltip"
          data-tooltip-placement="right"
          class="flex items-center justify-center w-12 h-12 rounded-xl text-gray-400 hover:text-blue-500 hover:bg-gray-800 mb-4"
        >
          <img
            class="w-8 rounded-xl single-link"
            src="../../assets/images/def_avatar.png"
            alt=""
          />
        </a>
        <div
          id="avatar-tooltip"
          role="tooltip"
          class="absolute invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700 w-32"
        >
          {{
            current_user.ime
              ? current_user.ime + " " + current_user.prezime
              : ""
          }}
        </div>

        <div
          data-tooltip-target="logout-tooltip"
          data-tooltip-placement="right"
          class="flex items-center justify-center w-12 h-12 rounded-xl text-white bg-red-600 single-link cursor-pointer"
          href="#"
          @click="handleLogout()"
        >
          <svg
            width="20"
            height="20"
            viewbox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.59 11.0001L8.29 13.2901C8.19627 13.3831 8.12188 13.4937 8.07111 13.6155C8.02034 13.7374 7.9942 13.8681 7.9942 14.0001C7.9942 14.1321 8.02034 14.2628 8.07111 14.3847C8.12188 14.5065 8.19627 14.6171 8.29 14.7101C8.38296 14.8038 8.49356 14.8782 8.61542 14.929C8.73728 14.9798 8.86799 15.0059 9 15.0059C9.13201 15.0059 9.26272 14.9798 9.38458 14.929C9.50644 14.8782 9.61704 14.8038 9.71 14.7101L13.71 10.7101C13.801 10.615 13.8724 10.5029 13.92 10.3801C14.02 10.1366 14.02 9.86356 13.92 9.6201C13.8724 9.49735 13.801 9.3852 13.71 9.2901L9.71 5.2901C9.61676 5.19686 9.50607 5.1229 9.38425 5.07244C9.26243 5.02198 9.13186 4.99601 9 4.99601C8.86814 4.99601 8.73757 5.02198 8.61575 5.07244C8.49393 5.1229 8.38324 5.19686 8.29 5.2901C8.19676 5.38334 8.1228 5.49403 8.07234 5.61585C8.02188 5.73767 7.99591 5.86824 7.99591 6.0001C7.99591 6.13196 8.02188 6.26253 8.07234 6.38435C8.1228 6.50617 8.19676 6.61686 8.29 6.7101L10.59 9.0001H1C0.734784 9.0001 0.48043 9.10546 0.292893 9.29299C0.105357 9.48053 0 9.73488 0 10.0001C0 10.2653 0.105357 10.5197 0.292893 10.7072C0.48043 10.8947 0.734784 11.0001 1 11.0001H10.59ZM10 9.96937e-05C8.13109 -0.00824409 6.29724 0.507313 4.70647 1.48829C3.11569 2.46927 1.83165 3.87641 1 5.5501C0.880653 5.78879 0.861015 6.06512 0.945406 6.3183C1.0298 6.57147 1.21131 6.78075 1.45 6.9001C1.68869 7.01945 1.96502 7.03909 2.2182 6.95469C2.47137 6.8703 2.68065 6.68879 2.8 6.4501C3.43219 5.17342 4.39383 4.08872 5.58555 3.30809C6.77727 2.52746 8.15582 2.07922 9.57876 2.00969C11.0017 1.94017 12.4174 2.25188 13.6795 2.91261C14.9417 3.57334 16.0045 4.55913 16.7581 5.7681C17.5118 6.97706 17.9289 8.36535 17.9664 9.78948C18.0039 11.2136 17.6605 12.6219 16.9715 13.8689C16.2826 15.1159 15.2731 16.1563 14.0475 16.8825C12.8219 17.6088 11.4246 17.9946 10 18.0001C8.50888 18.0066 7.04615 17.5925 5.77969 16.8053C4.51323 16.0182 3.49435 14.89 2.84 13.5501C2.72065 13.3114 2.51137 13.1299 2.2582 13.0455C2.00502 12.9611 1.72869 12.9808 1.49 13.1001C1.25131 13.2194 1.0698 13.4287 0.985406 13.6819C0.901015 13.9351 0.920653 14.2114 1.04 14.4501C1.83283 16.0456 3.03752 17.4003 4.52947 18.3741C6.02142 19.348 7.74645 19.9055 9.52612 19.9891C11.3058 20.0727 13.0755 19.6793 14.6521 18.8496C16.2288 18.0199 17.5552 16.7841 18.4941 15.2699C19.433 13.7558 19.9503 12.0182 19.9925 10.2371C20.0347 8.45597 19.6003 6.69589 18.7342 5.13893C17.8682 3.58197 16.6018 2.28467 15.0663 1.38121C13.5307 0.477745 11.7816 0.000936146 10 9.96937e-05Z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
        <div
          id="logout-tooltip"
          role="tooltip"
          class="absolute invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700"
        >
          Odjava
        </div> -->
      </div>
    </nav>
    <notification-bell class="absolute top-8 right-24"></notification-bell>
    <button
      id="dropdownUserAvatarButton"
      data-dropdown-toggle="dropdownAvatar"
      data-dropdown-offset-distance="10"
      data-dropdown-offset-skidding="-65"
      class="flex absolute top-8 right-10 text-sm bg-gray-800 rounded-full md:me-0"
      type="button"
    >
      <span class="sr-only">Podaci korisnika</span>
      <img
        class="w-8 h-8 rounded-full border border-white dark:border-gray-800 p-1"
        src="../../assets/images/def_avatar.png"
        alt="user photo"
      />
    </button>

    <!-- Dropdown menu -->
    <div
      id="dropdownAvatar"
      class="z-40 hidden bg-white divide-y divide-gray-100 rounded-lg shadow dark:bg-gray-700 dark:divide-gray-600"
    >
      <div class="px-4 py-3 text-sm text-gray-900 dark:text-white">
        <div>{{ current_user.ime }} {{ current_user.prezime }}</div>
        <div class="font-medium truncate text-gray-500">
          {{ current_user.username }}
        </div>
      </div>
      <div class="py-2" @click="handleLogout">
        <a
          href="#"
          class="block px-4 py-2 text-sm text-center text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white"
          >Odjavi se</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import store from "../../store";
import router from "@/router";
import gsap from "gsap";
import { useUserStore } from "@/store/auth.session";
import { initTooltips } from "flowbite";
import NotificationBell from "./NotificationBell.vue";
import { useNotificationStore } from "@/store/notifications";
import sound from '@/assets/sounds/notification.wav'


export default {
  setup() {
    const userStore = useUserStore();
    const current_user = ref(userStore.user_profile);
    const handleLogout = () => {
      userStore.logoutUser();
    };

    const notification_store = useNotificationStore();

    const notifications = ref(notification_store.notifications);

    const routeEqContains = (check_str, type) => {
      console.log(router.currentRoute.value);
      if (type == 1) {
        return router.currentRoute.value.fullPath == check_str;
      } else {
        return router.currentRoute.value.fullPath.startsWith(check_str);
      }
    };

    const comunication_notifications = computed(()=>{
      return notifications.value.filter((sn)=>{
        return !sn.opened && sn.link.startsWith('/comunication')    })
    })
    const file_notifications = computed(()=>{
      return notifications.value.filter((sn)=>{
        return(!sn.opened && sn.link.startsWith('/files'))
      })
    })

    console.log(router.currentRoute.value);
    onMounted(() => {
      gsap.from(".single-link", {
        duration: 1,
        scale: 0.8,
        opacity: 0,
        delay: 0.3,
        stagger: 0.2,
        ease: "power1.out",
        force3D: true,
      });
      initTooltips();
    });
    return {
      current_user,
      notifications,
      file_notifications,
      comunication_notifications,
      handleLogout,
      routeEqContains,
    };
  },
  components: { NotificationBell },
};
</script>
